import React from "react";

interface props {
    timeLeft: number;
}

const Timer: React.FC<props> = ({timeLeft}) => {
    return (
        <p className="text-xs text-gray-500">
            {`زمان باقیمانده: ${String(Math.floor(timeLeft / 60)).padStart(2, '0')}:${String(timeLeft % 60).padStart(2, '0')}`}
        </p>
    )
}

export default Timer;